import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export const DeleteBookmarkDialog = ({ open, onClose }) => {
	return (
		<Dialog
			maxWidth="sm"
			onClose={onClose}
			open={open}
			sx={{
				"& .MuiDialog-container": { justifyContent: "center" },
				"& .MuiDialog-paper": { width: "100%" },
			}}>
			<DialogContent>
				<Stack
					direction="row"
					spacing={2}
					sx={{
						alignItems: "center",
						flex: "0 0 auto",
						justifyContent: "space-between",
						p: 2,
					}}>
					<Typography variant="h6">Delete this bookmark?</Typography>
				</Stack>
				<Stack padding={2}>
					<Typography variant="body2">
						Once removed, this item cannot be recovered.
					</Typography>
				</Stack>
				<Stack
					direction={"row-reverse"}
					spacing={2}>
					<Button
						onClick={onClose}
						variant="contained">
						Delete
					</Button>
					<Button onClick={onClose}>Cancel</Button>
				</Stack>
			</DialogContent>
		</Dialog>
	);
};
